"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Vimeo;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Vimeo(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "Vimeo"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "vimeo",
    d: "M89.963,31.391Q89.428,43.07,73.642,63.373,57.33,84.588,46.035,84.587q-6.991,0-11.839-12.91c-6.286-23.072-8.964-36.589-14.16-36.589-.608,0-2.7,1.268-6.286,3.768L10,34c9.214-8.09,18.018-17.089,23.535-17.589q9.348-.91,11.5,12.767c5.125,32.41,7.393,37.3,16.714,22.625q5.008-7.929,5.393-12.071c.857-8.2-6.393-7.643-11.3-5.536q5.894-19.312,22.536-18.768c8.178.215,12.053,5.554,11.589,15.964Z"
  })));
}